import lodash from 'lodash';
import { configure } from 'mobx';
import * as Controller from './controller';
import Env from './env';
import { AjaxBasics, Log } from './libraries';
AjaxBasics.defaultAjaxConfig.statusPath = ['status', 'code', 'errorCode'];
AjaxBasics.defaultAjaxConfig.responsePath = ['data'];
AjaxBasics.defaultAjaxConfig.messagePath = ['msg', 'message', 'errorMsg'];
configure({ enforceActions: 'observed' });
export function createStore() {
    // 从 基座获取的全局状态
    const GlobalData = lodash.result(window, 'microApp.getGlobalData');
    // 基座 的 基础状态函数
    const inheritStore = lodash.get(GlobalData, 'inheritStore', initStore);
    const Store = inheritStore();
    AjaxBasics.merge = async (AjaxConfig) => {
        function setHeaders() {
            // 配置 token
            if (Store.System.AccessToken) {
                const isToken = lodash.some([], (item) => lodash.includes(AjaxConfig.url, item));
                const tokenKey = isToken ? 'token' : 'bp-token';
                lodash.merge(AjaxConfig, {
                    headers: { [tokenKey]: Store.System.AccessToken },
                });
            }
            // 分享码
            if (Store.Share.promoSource) {
                lodash.merge(AjaxConfig, {
                    headers: { 'x-source-website': Store.Share.promoSource },
                });
            }
            // 分享码
            if (Store.Share.shareCode) {
                lodash.merge(AjaxConfig, {
                    headers: { 'x-bp-promo-code': Store.Share.getHeaderValue() },
                });
            }
            // BU
            if (Store.Share.businessType) {
                lodash.merge(AjaxConfig, {
                    headers: { 'x-business-unit': Store.Share.businessType },
                });
            }
        }
        setHeaders();
        // 默认 所有请求都需要等待用户完成 带有标记 和 已完成 则跳过
        if (lodash.eq(AjaxConfig.awaitAuthenticated, false) ||
            Store.System.Auth.HydrateisStopped) {
            return AjaxConfig;
        }
        Log.warning(`等待用户初始化完成 【 ${AjaxConfig.url} 】`, AjaxConfig);
        await Store.System.Auth.HydrateAsync;
        setHeaders();
        return AjaxConfig;
    };
    return Store;
}
/**
 * 初始化状态
 * @returns
 */
function initStore() {
    return {
        /** 系统 登陆注册 */
        System: new Controller.SystemController(),
        /** 用户信息 */
        UserInfo: new Controller.UserInfoController(),
        /** 微信 */
        Wechat: new Controller.WechatController(Env.appid),
        /** 分享 */
        Share: new Controller.ShareController(),
        /** 非业务公共 */
        Currency: new Controller.CurrencyController(),
        /** 协议 */
        Protocol: new Controller.ProtocolController(),
    };
}
